module.exports = __webpack_public_path__ + "img/lsk.aab8a26a.svg";